import { mix, clamp, mixColor, createPathMorph, createSvg, INK, PINK } from './helpers.js';


const NS = "http://www.w3.org/2000/svg";

function renderMarketing() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);
    const items = [
        {
            type: "circle",
            start: { x: 75, y: 155, w: 10, h: 10, op: 1, pop: 0.5, color: INK },
            end: { x: 215, y: 155, w: 10, h: 10, op: 1, pop: 1, color: PINK },
        },
        {
            type: "ellipse",
            start: {
                x: 30,
                y: 145,
                w: 100,
                h: 30,
                op: 0.2,
                pop: 0.5,
                color: INK,
                dash: "1 6",
                sw: 2,
            },
            end: {
                x: 170,
                y: 145,
                w: 100,
                h: 30,
                op: 0.2,
                pop: 1,
                color: PINK,
                dash: "1 6",
                sw: 2,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 20,
                y: 130,
                w: 140,
                h: 60,
                op: 0.4,
                pop: 0.5,
                color: INK,
                dash: "1 6",
                sw: 2,
            },
            end: {
                x: 150,
                y: 130,
                w: 140,
                h: 60,
                op: 0.4,
                pop: 1,
                color: PINK,
                dash: "1 6",
                sw: 2,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 10,
                y: 120,
                w: 180,
                h: 80,
                op: 0.4,
                pop: 0.5,
                color: INK,
                dash: "1 6",
                sw: 2,
            },
            end: {
                x: 130,
                y: 120,
                w: 180,
                h: 80,
                op: 0.4,
                pop: 1,
                color: PINK,
                dash: "1 6",
                sw: 2,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 20,
                y: 110,
                w: 190,
                h: 100,
                op: 0.4,
                pop: 0.5,
                color: INK,
                dash: "1 10",
                sw: 2,
            },
            end: {
                x: 110,
                y: 110,
                w: 190,
                h: 100,
                op: 0.4,
                pop: 1,
                color: PINK,
                dash: "1 10",
                sw: 2,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 30,
                y: 100,
                w: 200,
                h: 120,
                op: 0.4,
                pop: 0.5,
                color: INK,
                dash: "1 10",
                sw: 2,
            },
            end: {
                x: 90,
                y: 100,
                w: 200,
                h: 120,
                op: 0.4,
                pop: 1,
                color: PINK,
                dash: "1 10",
                sw: 2,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 50,
                y: 90,
                w: 200,
                h: 140,
                op: 0.4,
                pop: 0.5,
                color: INK,
                dash: "1 10",
                sw: 3,
            },
            end: {
                x: 70,
                y: 90,
                w: 200,
                h: 140,
                op: 0.4,
                pop: 1,
                color: PINK,
                dash: "1 10",
                sw: 3,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 70,
                y: 80,
                w: 200,
                h: 160,
                op: 0.6,
                pop: 0.5,
                color: INK,
                dash: "1 10",
                sw: 3,
            },
            end: {
                x: 50,
                y: 80,
                w: 200,
                h: 160,
                op: 0.6,
                pop: 1,
                color: PINK,
                dash: "1 10",
                sw: 3,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 90,
                y: 70,
                w: 200,
                h: 180,
                op: 0.8,
                pop: 0.5,
                color: INK,
                dash: "1 12",
                sw: 4,
            },
            end: {
                x: 30,
                y: 70,
                w: 200,
                h: 180,
                op: 0.8,
                pop: 1,
                color: PINK,
                dash: "1 12",
                sw: 4,
            },
        },
        {
            type: "ellipse",
            start: {
                x: 110,
                y: 60,
                w: 200,
                h: 200,
                op: 1,
                pop: 0.5,
                color: INK,
                dash: "1 12",
                sw: 4,
            },
            end: {
                x: 10,
                y: 60,
                w: 200,
                h: 200,
                op: 1,
                pop: 1,
                color: PINK,
                dash: "1 12",
                sw: 4,
            },
        },
    ];

    const nodes = items.map((item) => {
        const el = document.createElementNS(NS, item.type);
        el.classList.add(
            item.type === "circle"
                ? "animatedVisualSwap__vectorDot"
                : "animatedVisualSwap__vectorShape",
        );
        layer.appendChild(el);
        return el;
    });
    return {
        node: svg,
        apply(progress) {
            const groupOpacity = mix(0.5, 1, progress);

            nodes.forEach((node, index) => {
                const item = items[index];
                const from = item.start;
                const to = item.end;
                const x = mix(from.x, to.x, progress);
                const y = mix(from.y, to.y, progress);
                const w = mix(from.w, to.w, progress);
                const h = mix(from.h, to.h, progress);
                const color = mixColor(from.color, to.color, progress);
                const alpha = clamp(
                    groupOpacity *
                        mix(from.pop, to.pop, progress) *
                        mix(from.op, to.op, progress),
                    0,
                    1,
                );

                if (item.type === "circle") {
                    node.setAttribute("cx", String(x + w / 2));
                    node.setAttribute("cy", String(y + h / 2));
                    node.setAttribute("r", String(w / 2));
                    node.setAttribute("fill", color);
                    node.setAttribute("fill-opacity", String(alpha));
                } else {
                    node.setAttribute("cx", String(x + w / 2));
                    node.setAttribute("cy", String(y + h / 2));
                    node.setAttribute("rx", String(w / 2));
                    node.setAttribute("ry", String(h / 2));
                    node.setAttribute("fill", "none");
                    node.setAttribute("stroke", color);
                    node.setAttribute(
                        "stroke-width",
                        String(mix(from.sw, to.sw, progress)),
                    );
                    node.setAttribute(
                        "stroke-dasharray",
                        progress < 0.5 ? from.dash : to.dash,
                    );
                    node.setAttribute("stroke-opacity", String(alpha));
                }
            });
        },
    };
}

function renderPolitics() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);
    const arcs = [
        {
            start: { x: 30, y: 115, w: 260, h: 130, op: 0.6, sw: 2, pop: 0.9 },
            end: { x: 20, y: 105, w: 280, h: 140, op: 0.9, sw: 6, pop: 1 },
        },
        {
            start: { x: 50, y: 135, w: 220, h: 110, op: 0.6, sw: 3, pop: 0.9 },
            end: { x: 40, y: 125, w: 240, h: 120, op: 0.8, sw: 5, pop: 1 },
        },
        {
            start: { x: 70, y: 155, w: 180, h: 90, op: 0.6, sw: 3, pop: 0.9 },
            end: { x: 60, y: 145, w: 200, h: 100, op: 0.6, sw: 4, pop: 1 },
        },
        {
            start: { x: 90, y: 175, w: 140, h: 70, op: 0.8, sw: 4, pop: 0.9 },
            end: { x: 80, y: 165, w: 160, h: 80, op: 0.5, sw: 3, pop: 1 },
        },
        {
            start: { x: 110, y: 195, w: 100, h: 50, op: 0.8, sw: 4, pop: 0.9 },
            end: { x: 100, y: 185, w: 120, h: 60, op: 0.4, sw: 3, pop: 1 },
        },
        {
            start: { x: 130, y: 215, w: 60, h: 30, op: 1, sw: 6, pop: 0.9 },
            end: { x: 120, y: 205, w: 80, h: 40, op: 0.2, sw: 2, pop: 1 },
        },
        {
            start: { x: 148, y: 233, w: 24, h: 12, op: 1, sw: 6, pop: 0.9 },
            end: { x: 136, y: 221, w: 48, h: 24, op: 0.2, sw: 2, pop: 1 },
        },
        {
            start: { x: 10, y: 95, w: 300, h: 150, op: 0.5, sw: 1, pop: 0.9 },
            end: { x: 4, y: 92, w: 312, h: 156, op: 1, sw: 6, pop: 1 },
        },
    ];

    const dot = {
        start: { x: 155, y: 240, w: 10, h: 10, op: 1, pop: 0.9 },
        end: { x: 152, y: 237, w: 16, h: 16, op: 1, pop: 1 },
    };
    const rowOrder = [6, 5, 4, 3, 2, 1, 0, 7];
    const rowRank = rowOrder.reduce((acc, index, rank) => {
        acc[index] = rank;
        return acc;
    }, {});

    function stagedProgress(progress, delay, span = 0.26) {
        const raw = clamp((progress - delay) / span, 0, 1);
        return 1 - (1 - raw) ** 3;
    }

    function ellipsePoint(x, y, w, h, t) {
        const theta = Math.PI - Math.PI * t;
        return {
            x: x + w / 2 + Math.cos(theta) * (w / 2),
            y: y + h - Math.sin(theta) * h,
        };
    }

    const arcNodes = arcs.map((arc, index) => {
        const count = Math.max(7, Math.round(arc.end.w / 9));
        return Array.from({ length: count }, (_, pointIndex) => {
            const circle = document.createElementNS(NS, "circle");
            circle.classList.add("animatedVisualSwap__vectorDot");
            circle.dataset.arcIndex = String(index);
            circle.dataset.pointIndex = String(pointIndex);
            layer.appendChild(circle);
            return circle;
        });
    });

    const dotNode = document.createElementNS(NS, "circle");
    dotNode.classList.add("animatedVisualSwap__vectorDot");
    layer.appendChild(dotNode);

    return {
        node: svg,
        apply(progress) {
            arcNodes.forEach((rowNodes, index) => {
                const from = arcs[index].start;
                const to = arcs[index].end;

                rowNodes.forEach((node, pointIndex) => {
                    const t =
                        rowNodes.length === 1
                            ? 0.5
                            : pointIndex / (rowNodes.length - 1);
                    const distanceFromCenter = Math.abs(t - 0.5) / 0.5;
                    const delay =
                        rowRank[index] * 0.055 + distanceFromCenter * 0.12;
                    const local = stagedProgress(progress, delay, 0.44);
                    const startPoint = ellipsePoint(
                        from.x,
                        from.y,
                        from.w,
                        from.h,
                        t,
                    );
                    const endPoint = ellipsePoint(to.x, to.y, to.w, to.h, t);
                    const point = {
                        x: mix(startPoint.x, endPoint.x, local),
                        y: mix(startPoint.y, endPoint.y, local),
                    };
                    const radius = mix(
                        Math.max(0.55, from.sw * 0.34),
                        Math.max(0.9, to.sw * 0.46),
                        local,
                    );
                    const alpha = clamp(
                        mix(0.5, 1, local) *
                            mix(from.pop, to.pop, local) *
                            mix(from.op, to.op, local),
                        0,
                        1,
                    );
                    node.setAttribute("cx", String(point.x));
                    node.setAttribute("cy", String(point.y));
                    node.setAttribute("r", String(radius));
                    node.setAttribute("fill", mixColor(INK, PINK, local));
                    node.setAttribute("fill-opacity", String(alpha));
                });
            });

            const dotLocal = stagedProgress(progress, 0, 0.22);
            const dx = mix(dot.start.x, dot.end.x, dotLocal);
            const dy = mix(dot.start.y, dot.end.y, dotLocal);
            const dw = mix(dot.start.w, dot.end.w, dotLocal);
            dotNode.setAttribute("cx", String(dx + dw / 2));
            dotNode.setAttribute("cy", String(dy + dw / 2));
            dotNode.setAttribute("r", String(dw / 2));
            dotNode.setAttribute("fill", mixColor(INK, PINK, dotLocal));
            dotNode.setAttribute(
                "fill-opacity",
                String(
                    clamp(
                        mix(0.5, 1, dotLocal) *
                            mix(dot.start.pop, dot.end.pop, dotLocal),
                        0,
                        1,
                    ),
                ),
            );
        },
    };
}

function renderMarket() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const rects = [
        {
            start: {
                x: 40,
                y: 149,
                w: 48,
                h: 48,
                rot: 0,
                op: 0.4,
                sw: 1,
                pop: 0.5,
                dash: "1 6",
            },
            end: {
                x: 170.133,
                y: 145.65,
                w: 17.237,
                h: 17.237,
                rot: 2,
                op: 1,
                sw: 4,
                pop: 1,
                dash: "1 12",
            },
        },
        {
            start: {
                x: 40,
                y: 137,
                w: 72,
                h: 72,
                rot: 0,
                op: 0.4,
                sw: 1,
                pop: 0.5,
                dash: "1 6",
            },
            end: {
                x: 153.992,
                y: 136.634,
                w: 42.486,
                h: 42.486,
                rot: 4,
                op: 0.8,
                sw: 4,
                pop: 1,
                dash: "1 6",
            },
        },
        {
            start: {
                x: 40,
                y: 125,
                w: 96,
                h: 96,
                rot: 0,
                op: 0.4,
                sw: 2,
                pop: 0.5,
                dash: "1 6",
            },
            end: {
                x: 132.428,
                y: 124.829,
                w: 76.17,
                h: 76.17,
                rot: 6,
                op: 0.8,
                sw: 4,
                pop: 1,
                dash: "1 6",
            },
        },
        {
            start: {
                x: 40,
                y: 113,
                w: 120,
                h: 120,
                rot: 0,
                op: 0.4,
                sw: 2,
                pop: 0.5,
                dash: "1 10",
            },
            end: {
                x: 113.847,
                y: 117.353,
                w: 102.808,
                h: 102.808,
                rot: 8,
                op: 0.8,
                sw: 4,
                pop: 1,
                dash: "1 10",
            },
        },
        {
            start: {
                x: 40,
                y: 101,
                w: 144,
                h: 144,
                rot: 0,
                op: 0.4,
                sw: 2,
                pop: 0.5,
                dash: "1 10",
            },
            end: {
                x: 93.676,
                y: 110.372,
                w: 130.945,
                h: 130.945,
                rot: 10,
                op: 0.8,
                sw: 4,
                pop: 1,
                dash: "1 10",
            },
        },
        {
            start: {
                x: 40,
                y: 89,
                w: 168,
                h: 168,
                rot: 0,
                op: 0.4,
                sw: 3,
                pop: 0.5,
                dash: "1 10",
            },
            end: {
                x: 75.369,
                y: 106.263,
                w: 154.753,
                h: 154.753,
                rot: 12,
                op: 0.8,
                sw: 4,
                pop: 1,
                dash: "1 10",
            },
        },
        {
            start: {
                x: 40,
                y: 77,
                w: 192,
                h: 192,
                rot: 0,
                op: 0.6,
                sw: 3,
                pop: 0.5,
                dash: "1 10",
            },
            end: {
                x: 55.09,
                y: 102.344,
                w: 180.942,
                h: 180.942,
                rot: 14,
                op: 0.6,
                sw: 4,
                pop: 1,
                dash: "1 10",
            },
        },
        {
            start: {
                x: 40,
                y: 65,
                w: 216,
                h: 216,
                rot: 0,
                op: 0.8,
                sw: 4,
                pop: 0.5,
                dash: "1 12",
            },
            end: {
                x: 34.281,
                y: 99.612,
                w: 207.131,
                h: 207.131,
                rot: 16,
                op: 0.4,
                sw: 4,
                pop: 1,
                dash: "1 12",
            },
        },
        {
            start: {
                x: 40,
                y: 53,
                w: 240,
                h: 240,
                rot: 0,
                op: 1,
                sw: 4,
                pop: 0.5,
                dash: "1 12",
            },
            end: {
                x: 10,
                y: 96.571,
                w: 238.082,
                h: 238.082,
                rot: 18,
                op: 0.2,
                sw: 4,
                pop: 1,
                dash: "1 12",
            },
        },
    ];

    const nodes = rects.map(() => {
        const rect = document.createElementNS(NS, "rect");
        rect.classList.add("animatedVisualSwap__vectorShape");
        rect.setAttribute("fill", "none");
        rect.setAttribute("rx", "4");
        layer.appendChild(rect);
        return rect;
    });

    return {
        node: svg,
        apply(progress) {
            const groupOpacity = mix(0.5, 1, progress);
            nodes.forEach((node, index) => {
                const from = rects[index].start;
                const to = rects[index].end;
                const x = mix(from.x, to.x, progress);
                const y = mix(from.y, to.y, progress);
                const w = mix(from.w, to.w, progress);
                const h = mix(from.h, to.h, progress);
                const rot = mix(from.rot, to.rot, progress);
                node.setAttribute("x", String(x));
                node.setAttribute("y", String(y));
                node.setAttribute("width", String(w));
                node.setAttribute("height", String(h));
                node.setAttribute(
                    "transform",
                    `rotate(${rot} ${x + w / 2} ${y + h / 2})`,
                );
                node.setAttribute("stroke", mixColor(INK, PINK, progress));
                node.setAttribute(
                    "stroke-width",
                    String(mix(from.sw, to.sw, progress)),
                );
                node.setAttribute(
                    "stroke-dasharray",
                    progress < 0.5 ? from.dash : to.dash,
                );
                node.setAttribute(
                    "stroke-opacity",
                    String(
                        clamp(
                            groupOpacity *
                                mix(from.pop, to.pop, progress) *
                                mix(from.op, to.op, progress),
                            0,
                            1,
                        ),
                    ),
                );
            });
        },
    };
}

function renderNeuro() {
    const svg = createSvg();
    svg.classList.add("animatedVisualSwap__visual--clipped");
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const anchors = [
        { start: { x: 155, y: 154.9999, w: 10, h: 10, op: 1 }, end: { x: 152, y: 152, w: 16, h: 16, op: 1 } },
        { start: { x: 155.9999, y: 66.9999, w: 8, h: 8, op: 1 }, end: { x: 156, y: 67, w: 8, h: 8, op: 1 } },
        { start: { x: 155.9999, y: 244.9999, w: 8, h: 8, op: 1 }, end: { x: 156, y: 245, w: 8, h: 8, op: 1 } },
        { start: { x: 244.9999, y: 155.9999, w: 8, h: 8, op: 1 }, end: { x: 245, y: 156, w: 8, h: 8, op: 1 } },
        { start: { x: 66.9999, y: 155.9999, w: 8, h: 8, op: 1 }, end: { x: 67, y: 156, w: 8, h: 8, op: 1 } },
    ];

    const ellipses = [
        { start: { x: 145, y: 145, w: 30, h: 30, op: 0.2, sw: 2, dash: "1 6", paint: 0.5, rot: 0 }, end: { x: 145.0002, y: 145.0001, w: 30, h: 30, op: 0.2, sw: 2, dash: "1 6", paint: 1, rot: 0 } },
        { start: { x: 130, y: 130, w: 60, h: 60, op: 0.4, sw: 2, dash: "1 6", paint: 0.5, rot: 0 }, end: { x: 136, y: 136, w: 48, h: 48, op: 0.4, sw: 2, dash: "1 6", paint: 1, rot: 0 } },
        { start: { x: 110, y: 120, w: 100, h: 80, op: 0.6, sw: 3, dash: "1 12", paint: 0.5, rot: 0 }, end: { x: 122, y: 130, w: 76, h: 60, op: 0.6, sw: 3, dash: "1 12", paint: 1, rot: 0 } },
        { start: { x: 90, y: 110, w: 140, h: 100, op: 0.8, sw: 4, dash: "1 12", paint: 0.5, rot: 0 }, end: { x: 104, y: 120, w: 112, h: 80, op: 0.8, sw: 4, dash: "1 12", paint: 1, rot: 0 } },
        { start: { x: 60, y: 100, w: 200, h: 120, op: 1, sw: 4, dash: "1 12", paint: 0.5, rot: 0 }, end: { x: 71, y: 107, w: 178, h: 106, op: 1, sw: 4, dash: "1 12", paint: 1, rot: 0 } },
        { start: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 0.5, rot: 0 }, end: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 1, rot: -135 } },
        { start: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 0.5, rot: 45 }, end: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 1, rot: -45 } },
        { start: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 0.5, rot: 90 }, end: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 1, rot: 0 } },
        { start: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 0.5, rot: 135 }, end: { cx: 160, cy: 160, w: 300, h: 140, op: 0.4, sw: 2, dash: "1 6", paint: 1, rot: -90 } },
    ];

    const anchorNodes = anchors.map(() => {
        const el = document.createElementNS(NS, "circle");
        el.classList.add("animatedVisualSwap__vectorDot");
        layer.appendChild(el);
        return el;
    });

    const ellipseNodes = ellipses.map(() => {
        const el = document.createElementNS(NS, "ellipse");
        el.classList.add("animatedVisualSwap__vectorShape");
        el.setAttribute("fill", "none");
        el.setAttribute("stroke-linecap", "round");
        el.setAttribute("stroke-linejoin", "round");
        layer.appendChild(el);
        return el;
    });

    return {
        node: svg,
        apply(progress) {
            const eased = 1 - (1 - progress) ** 2;
            const groupOpacity = mix(0.5, 1, eased);

            anchorNodes.forEach((node, i) => {
                const from = anchors[i].start;
                const to = anchors[i].end;
                const x = mix(from.x, to.x, eased);
                const y = mix(from.y, to.y, eased);
                const w = mix(from.w, to.w, eased);
                node.setAttribute("cx", String(x + w / 2));
                node.setAttribute("cy", String(y + w / 2));
                node.setAttribute("r", String(w / 2));
                node.setAttribute("fill", mixColor(INK, PINK, eased));
                node.setAttribute("fill-opacity", String(clamp(groupOpacity * mix(0.5, 1, eased) * mix(from.op, to.op, eased), 0, 1)));
            });

            ellipseNodes.forEach((node, i) => {
                const from = ellipses[i].start;
                const to = ellipses[i].end;
                const local = i < 5 ? eased : eased ** 1.05;
                const w = mix(from.w, to.w, local);
                const h = mix(from.h, to.h, local);
                const cx = mix(from.cx != null ? from.cx : from.x + from.w / 2, to.cx != null ? to.cx : to.x + to.w / 2, local);
                const cy = mix(from.cy != null ? from.cy : from.y + from.h / 2, to.cy != null ? to.cy : to.y + to.h / 2, local);
                const rot = mix(from.rot, to.rot, local);

                if (i >= 5) {
                    node.setAttribute("cx", "0");
                    node.setAttribute("cy", "0");
                    node.setAttribute("transform", `translate(${cx} ${cy}) rotate(${rot})`);
                } else {
                    node.setAttribute("cx", String(cx));
                    node.setAttribute("cy", String(cy));
                    node.setAttribute("transform", `rotate(${rot} ${cx} ${cy})`);
                }

                node.setAttribute("rx", String(w / 2));
                node.setAttribute("ry", String(h / 2));
                node.setAttribute("stroke", mixColor(INK, PINK, local));
                node.setAttribute("stroke-width", String(mix(from.sw, to.sw, local)));
                node.setAttribute("stroke-dasharray", local < 0.5 ? from.dash : to.dash);
                node.setAttribute("stroke-opacity", String(clamp(groupOpacity * mix(from.paint, to.paint, local) * mix(from.op, to.op, local), 0, 1)));
            });
        },
    };
}

function renderJourney() {
    const svg = createSvg();
    svg.classList.add("animatedVisualSwap__visual--clipped");
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);
    const startDots = {
        "01":[175.61,158.68,2,0.2],"02":[176.35,165.86,2,0.2],"03":[176.01,174.4,2,0.2],"04":[173.09,182.01,2,0.2],"05":[167.68,188.68,2,0.2],"06":[160.11,193.61,2,0.2],"07":[151.22,195.97,2,0.2],"08":[141.43,195.13,2,0.2],"09":[132.11,191.61,2,0.2],"10":[124.06,184.68,2,0.2],"11":[118.22,175.8,2,0.2],"12":[115.74,165.33,2,0.2],"13":[116.61,153.92,2,0.2],"14":[120.61,142.84,2,0.2],"15":[128.66,133.31,2,0.2],"16":[139.43,126.6,2,0.2],"17":[152.12,123.57,2,0.2],"18":[165.68,124.6,2,0.2],"19":[178.35,129.61,2,0.2],"20":[189.27,138.84,2,0.2],"21":[196.93,151.32,2,0.2],"22":[200.4,165.86,2,0.2],"23":[198.61,180.68,3,0.3],"24":[192.61,195.68,3,0.3],"25":[181.61,207.68,3,0.3],"26":[166.68,216.45,3,0.3],"27":[150.61,219.68,3,0.3],"28":[133.61,217.68,3,0.3],"29":[117.58,210.9,3,0.3],"30":[104.02,198.97,3,0.3],"31":[94.7,183.01,3,0.3],"32":[90.68,164.86,3,0.3],"33":[93.24,145.44,3,0.3],"34":[101.21,127.6,3,0.3],"35":[114.61,112.84,3,0.3],"36":[131.84,102.67,3,0.3],"37":[151.61,98.29,3,0.3],"38":[173.05,101.25,3,0.3],"39":[192.59,109.79,3,0.3],"40":[208.74,124.61,3,0.3],"41":[219.66,143.84,3,0.3],"42":[224.22,164.86,4,0.3],"43":[222.22,186.68,4,0.3],"44":[212.59,207.9,4,0.3],"45":[196.93,225.14,4,0.3],"46":[175.94,237.18,4,0.3],"47":[151.9,242.19,4,0.3],"48":[127.1,239.69,4,0.3],"49":[104.32,229.14,4,0.3],"50":[85.33,211.9,4,0.3],"51":[72.71,189.68,4,0.3],"52":[67.39,163.86,4,0.3],"53":[70.15,136.84,4,0.3],"54":[81.16,112.84,4,0.3],"55":[100.21,92.24,4,0.3],"56":[124.14,78.57,4,0.3],"57":[152.12,73.35,4,0.3],"58":[180.88,76.57,4,0.3],"59":[206.74,88.62,4,0.3],"60":[227.95,109.29,4,0.3],"61":[242.12,134.84,4,0.3],"62":[247.33,163.33,5,0.3],"63":[244.12,193.18,5,0.4],"64":[230.99,221.18,5,0.4],"65":[210.09,243.69,5,0.4],"66":[182.11,258.69,5,0.4],"67":[151.11,264.77,5,0.4],"68":[119.22,261.19,5,0.4],"69":[89.74,247.6,5,0.4],"70":[66.39,225.14,5,0.4],"71":[49.84,195.97,5,0.4],"72":[43.1,162.86,5,0.4],"73":[48.1,129.31,5,0.4],"74":[62.39,98.75,5,0.4],"75":[85.68,72.85,5,0.4],"76":[116.74,56.15,5,0.4],"77":[152.11,49.36,5,0.4],"78":[187.59,54.36,5,0.4],"79":[220.16,69.36,5,0.4],"80":[247.33,94.79,5,0.4],"81":[264.17,126.11,5,0.4],"82":[271.45,162.33,6,0.4],"83":[266.17,199.54,6,0.5],"84":[249.83,234.18,6,0.5],"85":[224.22,261.77,6,0.5],"86":[189.27,280.79,6,0.5],"87":[150.9,288.36,6,0.5],"88":[111.74,282.36,6,0.5],"89":[75.84,266.19,6,0.5],"90":[46.34,238.19,6,0.5],"91":[26.6,203.18,6,0.5],"92":[19,162.33,6,0.5],"93":[25,121.61,6,0.5],"94":[42.1,83.71,6,0.5],"95":[71.15,53.36,6,0.5],"96":[108.61,32.76,6,0.5],"97":[151.61,25,6,0.5],"98":[193.93,31,6,0.5],"99":[233.26,49.36,6,0.5],"100":[265.45,79.57,6,0.5],"101":[287.33,118.61,6,0.5],"102":[295.23,162.33,6,0.5]
    };
    const endDots = {
        "01":[155,138,6,1],"103":[148,144,6,1],"104":[147,152,6,1],"105":[153,159,6,1],"106":[162,158,6,1],"107":[165,150,6,1],"108":[154,147,10,1],"02":[162,137,6,1],"03":[171,138,6,1],"04":[178,141,6,1],"05":[185,146,6,1],"06":[190,154,6,1],"07":[192,163,6,1],"08":[192,172,6,1],"09":[188,182,6,1],"10":[181,190,6,1],"11":[172,196,6,1],"12":[162,198,6,1],"13":[150,197,6,1],"14":[139,193,6,1],"15":[130,185,6,1],"16":[123,174,6,1],"17":[120,162,6,1],"18":[121,148,6,1],"19":[126,135,6,1],"20":[135,125,6,1],"21":[148,117,6,1],"22":[162,113,6,1],"23":[179,116,5,0.8],"24":[194,122,5,0.8],"25":[206,133,5,0.8],"26":[215,148,5,0.8],"27":[218,164,5,0.8],"28":[216,181,5,0.8],"29":[209,197,5,0.8],"30":[197,211,5,0.8],"31":[181,220,5,0.8],"32":[163,224,5,0.8],"33":[144,222,5,0.8],"34":[126,214,5,0.8],"35":[111,200,5,0.8],"36":[101,183,5,0.8],"37":[97,163,5,0.8],"38":[100,142,5,0.8],"39":[108,122,5,0.8],"40":[123,106,5,0.8],"41":[142,95,5,0.8],"42":[165.29,91.57,4,0.6],"43":[187.11,93.57,4,0.6],"44":[208.34,103.2,4,0.6],"45":[225.58,118.87,4,0.6],"46":[237.62,139.86,4,0.6],"47":[242.62,163.89,4,0.6],"48":[240.12,188.69,4,0.6],"49":[229.58,211.47,4,0.6],"50":[212.34,230.46,4,0.6],"51":[190.11,243.08,4,0.6],"52":[164.29,248.4,4,0.6],"53":[137.27,245.65,4,0.6],"54":[113.27,234.63,4,0.6],"55":[92.67,215.58,4,0.6],"56":[79,191.66,4,0.6],"57":[73.78,163.67,4,0.6],"58":[77,134.91,4,0.6],"59":[89.06,109.05,4,0.6],"60":[109.72,87.84,4,0.6],"61":[135.27,73.67,4,0.6],"62":[165,68,4,0.4],"63":[195,72,4,0.4],"64":[223,85,4,0.4],"65":[245,106,4,0.4],"66":[260,134,4,0.4],"67":[266,165,4,0.4],"68":[263,197,4,0.4],"69":[249,226,4,0.4],"70":[227,249,4,0.4],"71":[197,266,4,0.4],"72":[164,273,4,0.4],"73":[131,268,4,0.4],"74":[100,253,4,0.4],"75":[74,230,4,0.4],"76":[58,199,4,0.4],"77":[51,164,4,0.4],"78":[56,128,4,0.4],"79":[71,96,4,0.4],"80":[96,68,4,0.4],"81":[128,52,4,0.4],"82":[167,46,2,0.4],"83":[204,52,2,0.4],"84":[239,68,2,0.4],"85":[266,94,2,0.4],"86":[285,129,2,0.4],"87":[293,167,2,0.4],"88":[287,206,2,0.4],"89":[271,242,2,0.4],"90":[243,271,2,0.4],"91":[208,291,2,0.4],"92":[167,299,2,0.4],"93":[126,293,2,0.4],"94":[88,276,2,0.4],"95":[58,247,2,0.4],"96":[37,209,2,0.4],"97":[29,166,2,0.4],"98":[35,124,2,0.4],"99":[54,85,2,0.4],"100":[84,52,2,0.4],"101":[123,30,2,0.4],"102":[167,23,2,0.4]
    };
    const dotNames = ["01","103","104","105","106","107","108","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62","63","64","65","66","67","68","69","70","71","72","73","74","75","76","77","78","79","80","81","82","83","84","85","86","87","88","89","90","91","92","93","94","95","96","97","98","99","100","101","102"];
    const nodes = dotNames.map(() => {
        const node = document.createElementNS(NS, "circle");
        node.classList.add("animatedVisualSwap__vectorDot");
        layer.appendChild(node);
        return node;
    });

    return {
        node: svg,
        apply(progress) {
            nodes.forEach((node, index) => {
                const name = dotNames[index];
                const to = endDots[name];
                const from = startDots[name] || [160, 160, 0, 0];
                const x = mix(from[0], to[0], progress);
                const y = mix(from[1], to[1], progress);
                const size = mix(from[2], to[2], progress);
                const opacity = mix(from[3] * 0.5, to[3], progress);
                node.setAttribute("cx", String(x + size / 2));
                node.setAttribute("cy", String(y + size / 2));
                node.setAttribute("r", String(size / 2));
                node.setAttribute("fill", mixColor(INK, PINK, progress));
                node.setAttribute("fill-opacity", String(clamp(opacity, 0, 1)));
            });
        },
    };
}

function renderMystery() {
    const svg = createSvg();
    svg.classList.add("animatedVisualSwap__visual--clipped");
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);
    const polygons = [
        { start: { x: 135.28, y: 132.001, op: 0.4, sw: 2, dash: "1 6", d: "M 0 14.03077586273809 L 24.961034774780273 0 L 49.92206954956055 14.03077586273809 M 0 14.03077586273809 L 0 40.391314863296856 L 24.961034774780273 54.42209243774414 M 0 14.03077586273809 L 24.961034774780273 28.06155172547618 M 24.961034774780273 28.06155172547618 L 24.961034774780273 41.24182208161016 L 24.961034774780273 54.42209243774414 M 24.961034774780273 28.06155172547618 L 49.92206954956055 14.03077586273809 M 49.92206954956055 14.03077586273809 L 49.92206954956055 40.391314863296856 L 24.961034774780273 54.42209243774414" }, end: { x: 106, y: 99, op: 0.4, sw: 2, dash: "1 6", d: "M 0 30.164234824639585 L 54 0 L 108 30.164234824639585 M 0 30.164234824639585 L 0 86.8357614954215 L 54 117 M 0 30.164234824639585 L 54 60.32846964927917 M 54 60.32846964927917 L 54 88.66423482463958 L 54 117 M 54 60.32846964927917 L 108 30.164234824639585 M 108 30.164234824639585 L 108 86.8357614954215 L 54 117" } },
        { start: { x: 109.233, y: 101.846, op: 0.4, sw: 3, dash: "1 10", d: "M 50.66724140333911 0 L 102.0150833129883 29.605472356622872 L 102.0150833129883 87.23040962219238 L 50.66724140333911 116.30721282958986 L 0 87.23040962219238 L 0 29.605472356622872 L 50.66724140333911 0 Z" }, end: { x: 90, y: 80, op: 0.4, sw: 3, dash: "1 10", d: "M 70.02965449679978 0 L 141 40.72727272727273 L 141 120 L 70.02965449679978 160 L 0 120 L 0 40.72727272727273 L 70.02965449679978 0 Z" } },
        { start: { x: 85.991, y: 76, op: 0.6, sw: 3, dash: "1 10", d: "M 74.24961853027344 0 L 148.49923706054688 41.80767611314608 L 148.49923706054688 124.38410910580522 L 74.24961853027344 165.84547424316406 L 0 124.38410910580522 L 0.00004792805247352569 41.80767611314608 L 74.24961853027344 0 Z" }, end: { x: 70, y: 59, op: 0.6, sw: 3, dash: "1 10", d: "M 90 0 L 180 50.41762677448443 L 180 150.00000412846018 L 90 200 L 0 150.00000412846018 L 0.00005809490752950576 50.41762677448443 L 90 0 Z" } },
        { start: { x: 61.243, y: 48.001, op: 0.8, sw: 4, dash: "1 10", d: "M98.313 2.02264C98.619 1.849 98.9938 1.849 99.2999 2.02264L195.106 56.3781C195.419 56.5558 195.613 56.888 195.613 57.2479V165.929C195.613 166.289 195.419 166.621 195.106 166.799L99.2999 221.154C98.9938 221.328 98.619 221.328 98.313 221.154L2.50647 166.799C2.19339 166.621 1.99994 166.289 1.99994 165.929V57.2479C1.99994 56.888 2.1934 56.5558 2.50648 56.3781L98.313 2.02264Z" }, end: { x: 52, y: 38, op: 0.8, sw: 4, dash: "1 10", d: "M107.161 2.02262C107.468 1.84871 107.843 1.84871 108.149 2.02262L212.804 61.4547C213.117 61.6324 213.31 61.9645 213.31 62.3243V181.16C213.31 181.52 213.117 181.852 212.804 182.03L108.149 241.462C107.843 241.636 107.468 241.636 107.161 241.462L2.50637 182.03C2.19348 181.852 2.00018 181.52 2.00018 181.16V62.3243C2.00018 61.9645 2.19348 61.6324 2.50636 61.4547L107.161 2.02262Z" } },
        { start: { x: 39, y: 20, op: 1, sw: 4, dash: "1 10", d: "M 121.24355472662504 0 L 242.48713684082034 70.62937320807042 L 242.48713684082034 210 L 121.24355472662504 280 L 0 210 L 0.000013693785122374174 70.62937320807042 L 121.24355472662504 0 Z" }, end: { x: 39, y: 20, op: 1, sw: 4, dash: "1 10", d: "M 121.24355472662504 0 L 242.48713684082034 70.62937320807042 L 242.48713684082034 210 L 121.24355472662504 280 L 0 210 L 0.000013693785122374174 70.62937320807042 L 121.24355472662504 0 Z" } },
    ];
    const connectors = [
        { start: { d: "M110.318 131.941L87.527 118.847", op: 0.4, sw: 2, dash: "1 6" }, end: { d: "M89.318 119.941L73.464 110.833", op: 0.4, sw: 3, dash: "1 10" } },
        { start: { d: "M210.06 132.001L233.487 118.541", op: 0.4, sw: 2, dash: "1 6" }, end: { d: "M231 120.458L250.487 109", op: 0.4, sw: 3, dash: "1 10" } },
        { start: { d: "M160.242 216.579L160.242 240.088", op: 0.4, sw: 2, dash: "1 6" }, end: { d: "M160 240L160 259", op: 0.4, sw: 3, dash: "1 10" } },
        { start: { d: "M160.242 268.769L160.242 297.845", op: 0.4, sw: 2, dash: "1 6" }, end: { d: "M160 280L160 298", op: 0.8, sw: 4, dash: "1 10" } },
        { start: { d: "M255.749 105.754L280.71 91.4147", op: 0.4, sw: 2, dash: "1 6" }, end: { d: "M266 100L280.71 91.4147", op: 0.8, sw: 4, dash: "1 10" } },
        { start: { d: "M64.74 105.756L39.7797 91.4167", op: 0.4, sw: 2, dash: "1 6" }, end: { d: "M55 100L39.7797 91.4167", op: 0.8, sw: 4, dash: "1 10" } },
    ];
    const polygonMorphs = polygons.map((polygon) => createPathMorph(polygon.start.d, polygon.end.d));
    const connectorMorphs = connectors.map((connector) => createPathMorph(connector.start.d, connector.end.d));
    const polygonNodes = polygons.map(() => {
        const node = document.createElementNS(NS, "path");
        node.classList.add("animatedVisualSwap__vectorShape");
        node.setAttribute("fill", "none");
        node.setAttribute("stroke-linecap", "round");
        node.setAttribute("stroke-linejoin", "miter");
        layer.appendChild(node);
        return node;
    });
    const connectorNodes = connectors.map(() => {
        const node = document.createElementNS(NS, "path");
        node.classList.add("animatedVisualSwap__vectorShape");
        node.setAttribute("fill", "none");
        node.setAttribute("stroke-linecap", "round");
        node.setAttribute("stroke-linejoin", "miter");
        layer.appendChild(node);
        return node;
    });

    return {
        node: svg,
        apply(progress) {
            const eased = 1 - (1 - progress) ** 2.2;

            polygonNodes.forEach((node, index) => {
                const polygon = polygons[index];
                const from = polygon.start;
                const to = polygon.end;
                node.setAttribute("d", polygonMorphs[index](eased));
                node.setAttribute("transform", `translate(${mix(from.x, to.x, eased)} ${mix(from.y, to.y, eased)})`);
                node.setAttribute("stroke", mixColor(INK, PINK, eased));
                node.setAttribute("stroke-width", String(mix(from.sw, to.sw, eased)));
                node.setAttribute("stroke-dasharray", eased < 0.45 ? from.dash : to.dash);
                node.setAttribute("stroke-opacity", String(clamp(mix(0.25 * from.op, to.op, eased), 0, 1)));
            });

            connectorNodes.forEach((node, index) => {
                const connector = connectors[index];
                const from = connector.start;
                const to = connector.end;
                node.setAttribute("d", connectorMorphs[index](eased));
                node.setAttribute("stroke", mixColor(INK, PINK, eased));
                node.setAttribute("stroke-width", String(mix(from.sw, to.sw, eased)));
                node.setAttribute("stroke-dasharray", eased < 0.45 ? from.dash : to.dash);
                node.setAttribute("stroke-opacity", String(clamp(mix(0.25 * from.op, to.op, eased), 0, 1)));
            });
        },
    };
}

export { renderMarketing, renderPolitics, renderMarket, renderNeuro, renderJourney, renderMystery };
